// extracted by mini-css-extract-plugin
export default {"app-layout":"AppLayout_app-layout__L49OP","app-body":"AppLayout_app-body__a2L5J","main-content":"AppLayout_main-content__uK-Pd"};